<template lang='pug'>
  v-card.testSuite-card.mr-0.ml-0
    v-card-title
      v-row(no-gutters)
        v-col(no-gutters)
          .text-h5.font-weight-light.text-ellipsis {{testSuite.name}}
          .text-caption.font-weight-light.text-ellipsis {{baseUrl}}
        v-spacer
        bionic-metrics-test-status-indicator(
          v-if='showStatusIndicator'
          :status='suiteStatus.status'
          :testSuite='testSuite').mr-2
        bionic-metrics-running-indicator-circular(
          v-if='isRunning'
          :testSuite='testSuite'
          @cancelled='onCancelled').mr-2
        v-tooltip(bottom)
          template(v-slot:activator='{on}')
            v-btn.tight-button(v-on='on' @click='to(`/testsuite/${testSuite.guid}`)' icon)
              v-icon edit
          span Edit
        bionic-metrics-run-buttons(
          @starting='(e) => $emit("starting", e)'
          :dashboardGuid='dashboardGuid'
          :testSuite='testSuite'
          :suiteStatus='suiteStatus')
    div(v-if='listView')
      v-divider
      bionic-metrics-test-row(
        v-for='(test, index) in testSuite.tests'
        :key='index'
        :testSuite='testSuite'
        :test='test'
        :index='index'
        :test-status='status[`${testSuite.runGuid}-${test.guid}-${index}`]')
    v-card-text(v-if='!listView')
      v-row(wrap justify='center')
        bionic-metrics-test-tile(
          v-for='(test, index) in testSuite.tests'
          :key='index'
          :testSuite='testSuite'
          :test='test'
          :index='index'
          :test-status='status[`${testSuite.runGuid}-${test.guid}-${index}`]')
    .preview
      bionic-metrics-log-preview(:log='previewLog')
      .text-caption.font-weight-light(v-if='targetVersion') {{targetVersion}}
</template>

<script>
import BionicMetricsTestRow from '@/components/TestRow';
import UtilMixin from '@/mixins/util.mixin';
import BionicMetricsTestStatusIndicator from '@/components/TestStatusIndicator';
import BionicMetricsRunningIndicatorCircular from '@/components/RunningIndicatorCircular';
import BionicMetricsRunButtons from '@/components/RunButtons';
import BionicMetricsTestTile from '@/components/TestTile';
import BionicMetricsLogPreview from '@/components/LogPreview';

export default {
  name: 'BionicMetricsTestStatusCard',
  components: {
    BionicMetricsTestRow,
    BionicMetricsLogPreview,
    BionicMetricsTestTile,
    BionicMetricsRunButtons,
    BionicMetricsRunningIndicatorCircular,
    BionicMetricsTestStatusIndicator
  },
  mixins: [UtilMixin],
  props: {
    dashboardGuid: {
      type: String
    },
    testSuite: {
      type: Object
    },
    status: {
      type: Object
    },
    suiteStatus: {
      type: Object
    },
    previewLog: {
      type: String
    },
    listView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    baseUrl() {
      if (!this.testSuite || !this.suiteStatus) return null;
      return this.suiteStatus.baseUrl;
    },
    isStarting() {
      return this.suiteStatus && this.suiteStatus.isStarting;
    },
    isIncomplete() {
      return this.suiteStatus && this.suiteStatus.status === 'INCOMPLETE';
    },
    isRunning() {
      return this.suiteStatus
          && (this.suiteStatus.isRunning
              || this.suiteStatus.isStarting
              || this.suiteStatus.status === 'INCOMPLETE');
    },
    showStatusIndicator() {
      return this.suiteStatus && this.suiteStatus.status && !this.isRunning;
    },
    targetVersion() {
      return this.suiteStatus && this.suiteStatus.targetVersion;
    }
  },
  methods: {
    onCancelled() {
      this.$emit('cancelled', this.testSuite);
    }
  }
};
</script>

<style scoped>

.testSuite-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1vmin;
}

.tight-button {
  margin: 0;
  padding: 0;
}

.preview {
  display: inline-block;
  margin-top: auto;
  padding: 5px;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
